import { render, staticRenderFns } from "./KgjtWebsiteSubsidiaryCompanyEdit.vue?vue&type=template&id=5e0db1e2&scoped=true&"
import script from "./KgjtWebsiteSubsidiaryCompanyEdit.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteSubsidiaryCompanyEdit.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteSubsidiaryCompanyEdit.vue?vue&type=style&index=0&id=5e0db1e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0db1e2",
  null
  
)

export default component.exports